import React, { useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { MascotIntro } from './components/MascotIntro';
import { Services } from './components/Services';
import { WhyChoose } from './components/WhyChoose';
import { HowItWorks } from './components/HowItWorks';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { ExtraServices } from './components/ExtraServices';
import { About } from './components/About';
import { ServiceArea } from './components/ServiceArea';
import { Faq } from './components/Faq';
import { BookingForm } from './components/BookingForm';
import { FloatingActions } from './components/FloatingActions';
import { Footer } from './components/Footer';
import { business } from './data/business';
interface AppProps {
  defaultLanguage?: 'en' | 'es';
  showMascotSection?: boolean;
}
export function App({
  defaultLanguage = 'en',
  showMascotSection = true
}: AppProps) {
  useEffect(() => {
    document.title = `${business.name} | Professional Deep Cleaning in Houston, TX`;
    const setMeta = (name: string, content: string) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta('description', 'Professional residential and commercial deep cleaning in Houston, TX. Free estimates, same-day service, eco-friendly products. Se habla español. Call +1 (832) 719-7399.');
    setMeta('keywords', 'house cleaning Houston, deep cleaning, move out cleaning, limpieza Houston');
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HouseCleaningService',
      name: business.name,
      telephone: business.phone,
      email: business.email,
      url: `https://${business.website}`,
      areaServed: 'Houston, Texas',
      priceRange: '$49-$499',
      availableLanguage: ['English', 'Spanish'],
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Houston',
        addressRegion: 'TX',
        addressCountry: 'US'
      },
      openingHours: 'Mo-Sa 08:00-18:00',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '500'
      }
    };
    let script = document.getElementById('ld-json-3d-cleaning');
    if (!script) {
      script = document.createElement('script');
      script.id = 'ld-json-3d-cleaning';
      (script as HTMLScriptElement).type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  }, []);
  return <LanguageProvider initialLang={defaultLanguage} data-id="element-0" data-mp="2xu3jo3wxuuoc">
      <div className="min-h-screen w-full bg-white font-sans" data-id="element-1" data-mp="2xssebznuhev4">
        <AnnouncementBar data-id="element-2" data-mp="2sv0pjeihy8v5" />
        <Navbar data-id="element-3" data-mp="2svjza7xztqy3" />
        <main data-id="element-4" data-mp="2stzaz029v48o">
          <Hero data-id="element-5" data-mp="18e18ziepnkiz" />
          {showMascotSection ? <MascotIntro data-id="element-6" data-mp="18cznsl3zdhnj" /> : null}
          <Services data-id="element-7" data-mp="18bolyqu3ijz2" />
          <WhyChoose data-id="element-8" data-mp="1d47wfexhkyzn" />
          <HowItWorks data-id="element-9" data-mp="1d4rdyuj85ld5" />
          <Gallery data-id="element-10" data-mp="1d62iiwkhux5b" />
          <Testimonials data-id="element-11" data-mp="1d6kmyghb8hob" />
          <ExtraServices data-id="element-12" data-mp="yflfj8s7nz6b" />
          <About data-id="element-13" data-mp="ygd4i0rayynm" />
          <ServiceArea data-id="element-14" data-mp="ygwix7hqv4ww" />
          <Faq data-id="element-15" data-mp="ydija70gt9t5" />
          <BookingForm data-id="element-16" data-mp="13eoc04u4kx2o" />
        </main>
        <Footer data-id="element-17" data-mp="13fq0bb05jg2c" />
        <FloatingActions data-id="element-18" data-mp="13f7vhpzfbtit" />
      </div>
    </LanguageProvider>;
}